import React from "react";
import {
  Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue,
} from "@/components/ui/select";

// groups: [{ region, locations: [name, ...] }]
// leading: optional [{ value, label }] rendered before the groups (e.g. "All", "Anywhere")
export function LocationSelect({ value, onChange, groups = [], leading = [], testid, placeholder = "Select location", className = "mt-1.5 h-11" }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testid} className={className}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-h-80">
        {leading.map((o) => (
          <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
        ))}
        {groups.map((g) => (
          <SelectGroup key={g.region}>
            <SelectLabel className="text-emerald-700">{g.region}</SelectLabel>
            {g.locations.map((n) => (
              <SelectItem key={n} value={n}>{n}</SelectItem>
            ))}
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  );
}
